/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { Logo } from "../atoms";
import { TypeLogo } from "src/constants/theme.constant";

interface SidebarProps {
  menu?: JSX.Element,
  footer?: JSX.Element,
  isExpanded?: boolean,
};

const Sidebar = ({
  menu,
  footer,
  isExpanded = false,
}: SidebarProps) => {
  return (
    <div className="app-sidebar">
      <div className={`app-sidebar__logo ${isExpanded ? 'app-sidebar__logo--default':'app-sidebar__logo--isotipo'}`}>
        {isExpanded ? (
          <Logo color={TypeLogo.Default} />
        ) : (
          <Logo color={TypeLogo.Isotipo} />
        )}
      </div>
      <div className="app-sidebar__content">
        <div className="app-sidebar__menu app-menu">
          {menu}
        </div>
        <div className="app-sidebar__footer app-menu">
          {footer}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
